import fetch from '@/utils/fetch'
// 【消息】【列表】
export function message(params) {
  return fetch({
    url: '/message',
    method: 'get',
    params: {
      group_number: params.group_number,
      read_status: params.read_status,
      category: params.category,
      offset: params.offset,
      limit: params.limit
    }
  })
}
// 删除消息
export function deleteMessage(data) {
  return fetch({
    url: 'message/delMessage',
    method: 'post',
    data: {
      id: data.id
    }
  })
}